import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import Card from '../../elements/common/Card';
import handleValidationErrors from '../../helpers/ResponseErrorHelper';

import PromoCodeForm from './PromoCodeForm';

function PromoCodeCreate() {
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();

    const handleCreatePromoCode = async (newPromoCode) => {
        try {
            await CRMApi.post('promocode', newPromoCode);
            history.push('/promo_codes');
        } catch (error) {
            handleValidationErrors(error, setErrors);
            setIsLoading(false);
        }
    };

    return (
        <Card title="Create new promo code">
            <PromoCodeForm
                action={handleCreatePromoCode}
                errors={errors}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
        </Card>
    );
}

export default PromoCodeCreate;
